// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"6eece8a5","787":"c73cc71e"}[chunkId] + ".chunk.js";
};